<uniges-default-layout-list (onAdd)="handleAdd()" (onUpdate)="handleUpdate()" (onDelete)="handleDelete()"
    (onSelect)="handleSelect($event)" (onPrint)="handleImprimer()" tbRecherche="Article">
    <ng-template listItemContent let-element="listItem">
        <div class="p-20 min-h-20">
            <!-- Item template for the list -->
            {{ element.Art_Code }}
        </div>
    </ng-template>
    <div *listHeaderContent>
        Articles
    </div>
    <ng-template detailsContent let-element="element">
        <!-- Details component here with element as [input] -->
        <div class="p-10" fxLayoutAlign="end center">
            <button (click)="save()" color="primary" mat-raised-button>Enregistrer</button>
        </div>
        <div class="p-10" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px" *ngIf="formGroup"
            [formGroup]="formGroup">
            <ng-container *ngFor="let item of propNames">
                <ng-container *ngIf="item != 'Art_Id' && item != 'U_timestamp'">
                    <mat-form-field
                        *ngIf="item.TableRD_Type == ChampRD_Type.Text || item.TableRD_Type == ChampRD_Type.Nombre"
                        appearance="outline">
                        <mat-label>{{ item.TableRD_Des }}</mat-label>
                        <input type="{{ item.TableRD_Type == ChampRD_Type.Nombre ? 'number': 'text' }}" matInput
                            placeholder="{{ item.TableRD_Des }}" formControlName="{{ item.TableRD_Champs }}">
                    </mat-form-field>
                    <unilog-recherche *ngIf="item.TableRD_Type == ChampRD_Type.Champs" recherche="{{ item.Param1 }}"
                        champsModel="{{ item.Param2 }}" champsAffiche="{{ item.Param3 }}"
                        formControlName="{{ item.TableRD_Champs }}" appearance="outline" label="{{ item.TableRD_Des }}"
                        [ServerSideFiltering]="true" textErreur="Not valid" [showError]="true" [api]='api'
                        placeholder="{{ item.TableRD_Des }}">
                    </unilog-recherche>
                    <unilog-diversys *ngIf="item.TableRD_Type ==  ChampRD_Type.ComboBox"
                        formControlName="{{ ChampRD_Type.Champs }}" placeholder="{{ item.TableRD_Des }}"
                        type="{{ item.Param1 }}"></unilog-diversys>
                    <mat-checkbox *ngIf="item.TableRD_Type == ChampRD_Type.Boolean"
                        formControlName="{{ item.TableRD_Champs }}">{{ item.TableRD_Des}}</mat-checkbox>
                </ng-container>
            </ng-container>
        </div>
    </ng-template>
</uniges-default-layout-list>